import { FC } from 'react'
import { ArpeggiLoader } from '../lazy-component'
import { useArpTokenGate } from '../token-gating/hooks'
import { ArpMainSection } from './components'
import { ArpSecondarySection } from './components/ArpSecondarySection'
import { useMediaDetails } from './hooks'

const Skeleton = () => <ArpeggiLoader />

export const ArpDetails: FC = () => {
  const { media, status } = useMediaDetails()
  const { canAccessArp, isLoading: tokenGateIsLoading } = useArpTokenGate(media)
  if (status !== 'ready' || tokenGateIsLoading) return <Skeleton />
  if (!canAccessArp) return null
  return (
    <>
      <ArpMainSection media={media} />
      <ArpSecondarySection media={media} />
    </>
  )
}
